import type { PropsWithChildren } from 'react';
import React, { useEffect, useMemo } from 'react';
import { useQuery, gql } from '@apollo/client';
import { getCurrentUser } from '#/graphql/queries';
import SessionContext, { type SessionContextType } from './SessionContext';
import { GetCurrentUserQuery } from '#/graphql/types';
import { stripAuthParams } from '#/common/utils/url';
import { initializeAmplitude, setAmplitudeUserId } from '#/common/services/AmplitudeService';

const getCurrentUserQuery = gql(getCurrentUser);

const SessionProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const { data, loading, error } = useQuery<GetCurrentUserQuery>(getCurrentUserQuery);

  const ctx = useMemo<SessionContextType>(() => {
    const response = data?.getCurrentUser;
    const { __typename, ...userData } = response?.data ?? {};
    return {
      ...userData,
      loading,
      error: response?.errors || error,
    };
  }, [data, loading, error]);

  useEffect(() => {
    initializeAmplitude();
    stripAuthParams();
  }, []);
  useEffect(() => {
    if (ctx.user?.id) {
      setAmplitudeUserId(ctx.user.id);
    }
    return () => {
      setAmplitudeUserId(undefined);
    };
  }, [ctx.user?.id]);

  return <SessionContext.Provider value={ctx}>{children}</SessionContext.Provider>;
};

export default React.memo(SessionProvider);
